import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { courses as mockCourses } from "@/mocks/courses";

/** 교육과정 — kangstudy_courses 읽기(공개). 실패 시 목업 폴백 + usingMock 플래그. */
export interface CourseView {
  id: string;
  title: string;
  description: string;
  price: number;
  type: string;
  level: string;
  learningMode: string[];
  learningSummary: string;
  thumbnail: string;
  lectureCount: number;
  duration: string;
  students: number;
}

function toView(r: Record<string, unknown>): CourseView {
  return {
    id: String(r.id),
    title: (r.title as string) || "",
    description: (r.description as string) || "",
    price: Number(r.price) || 0,
    type: (r.type as string) || "",
    level: (r.level as string) || "",
    learningMode: Array.isArray(r.learning_mode) ? (r.learning_mode as string[]) : [],
    learningSummary: (r.learning_summary as string) || "",
    thumbnail: (r.thumbnail as string) || "",
    lectureCount: Number(r.lecture_count) || 0,
    duration: (r.duration as string) || "",
    students: Number(r.students) || 0,
  };
}

export function useCourses() {
  const [courses, setCourses] = useState<CourseView[]>([]);
  const [loading, setLoading] = useState(true);
  const [usingMock, setUsingMock] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from("kangstudy_courses")
        .select("*")
        .eq("active", true)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      if (data && data.length > 0) {
        setCourses(data.map((r) => toView(r as Record<string, unknown>)));
        setUsingMock(false);
      } else {
        setCourses(mockCourses as unknown as CourseView[]);
        setUsingMock(true);
      }
    } catch (e) {
      console.error("[kangstudy] 교육과정 조회 실패 — 목업 폴백:", e);
      setCourses(mockCourses as unknown as CourseView[]);
      setUsingMock(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);
  return { courses, loading, usingMock };
}
